import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_RTKS_REQUEST = 'GET_RTKS_REQUEST';
export const GET_RTKS_SUCCESS = 'GET_RTKS_SUCCESS';
export const GET_RTKS_FAILURE = 'GET_RTKS_FAILURE';

function requestGetRtks() {
  return {
    type: GET_RTKS_REQUEST,
    isListLoading: true
  };
}

function receiveGetRtks(list) {
  return {
    type: GET_RTKS_SUCCESS,
    isListLoading: false,
    list,
    listError: null
  };
}

function rejectGetRtks(listError) {
  return {
    type: GET_RTKS_FAILURE,
    isListLoading: false,
    listError
  };
}

export function getRtks(pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery) {
  return (dispatch) => {
    dispatch(requestGetRtks());

    const promise = () => ApiService
      .getRtks(pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery)
      .then((response) => {
        dispatch(receiveGetRtks(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetRtks, true));
        }
      });
    return promise();
  };
}
